export const getResponsiveStyles = ({ theme, c, isRTL, isMobile, initState, showRightPanel, sidebarVisible, sidebarCollapsed, sidebarWidthPx }) => {
  const sidebarShown = typeof sidebarVisible === 'boolean' ? sidebarVisible : !(initState.selectedUser && isMobile);
  const resolvedWidth = isMobile ? '100%' : `${sidebarWidthPx || 380}px`;

  return ({
    container: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      background: c.mainBg,
      overflow: 'hidden',
      borderRadius: isMobile ? '0' : '20px',
      boxShadow: c.shadow,
      direction: isRTL ? 'rtl' : 'ltr',
      margin: '0',
      //boxSizing: 'border-box',
      minHeight: 0,
    },
    sidebar: {
      display: sidebarShown ? 'flex' : 'none',
      width: resolvedWidth,
      minWidth: resolvedWidth,
      background: c.sidebarBg,
      backdropFilter: c.glassEffect,
      borderRight: isRTL ? 'none' : `1px solid ${c.border}`,
      borderLeft: isRTL ? `1px solid ${c.border}` : 'none',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      transition: 'none',
    },
    resizeHandle: {
      display: isMobile ? 'none' : 'flex',
      width: '6px',
      cursor: 'col-resize',
      background: 'transparent',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      position: 'relative',
      zIndex: 10,
      transition: 'background 0.2s ease',
    },
    sidebarHeader: {
      padding: isMobile ? '16px' : '20px',
      borderBottom: `1px solid ${c.border}`,
      flexShrink: 0,
    },
    sidebarTitle: {
      fontSize: isMobile ? '20px' : '22px',
      fontWeight: 'bold',
      color: c.text,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '16px',
    },
    menuBtn: {
      width: '42px',
      height: '42px',
      borderRadius: '14px',
      border: `1px solid ${c.border}`,
      background: c.inputBg,
      color: c.text,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'transform 0.16s ease, background 0.16s ease',
    },
    searchContainer: { position: 'relative' },
    searchInput: {
      width: '100%',
      paddingLeft: isRTL ? '16px' : '44px',
      paddingRight: isRTL ? '44px' : '16px',
      paddingTop: '12px',
      paddingBottom: '12px',
      background: c.inputBg,
      border: `1px solid ${c.inputBorder}`,
      borderRadius: '12px',
      outline: 'none',
      fontSize: '14px',
      color: c.text,
      transition: 'all 0.3s ease',
    },
    searchIcon: {
      position: 'absolute',
      left: isRTL ? 'auto' : '14px',
      right: isRTL ? '14px' : 'auto',
      top: '50%',
      transform: 'translateY(-50%)',
      color: c.textSecondary,
      width: '18px',
      height: '18px',
    },
    usersList: { flex: 1, overflowY: 'auto', overflowX: 'hidden' },
    sectionTitle: {
      padding: '16px 20px 8px',
      fontSize: '11px',
      fontWeight: '700',
      color: c.textSecondary,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    groupsSection: {
      padding: '0 0 12px',
    },
    groupChips: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: '10px',
      padding: '0 16px 12px',
      overflowX: 'auto',
      overflowY: 'hidden',
      alignItems: 'center',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
    },
    groupChip: {
      padding: '10px 14px',
      borderRadius: '999px',
      background: c.inputBg,
      color: c.text,
      border: `1px solid ${c.border}`,
      fontSize: '13px',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      minWidth: 'fit-content',
      transition: 'all 0.2s ease',
      flexShrink: 0,
    },
    groupChipActive: {
      background: '#2e7cba',
      color: '#ffffff',
      borderColor: '#2e7cba',
    },
    conversationItem: {
      padding: '12px 16px',
      cursor: 'pointer',
      background: 'transparent',
      transition: 'all 0.2s ease',
      borderLeft: isRTL ? 'none' : '3px solid transparent',
      borderRight: isRTL ? '3px solid transparent' : 'none',
    },
    conversationItemActive: {
      background: c.hoverBg,
      borderLeftColor: isRTL ? 'transparent' : '#2e7cba',
      borderRightColor: isRTL ? '#2e7cba' : 'transparent',
    },
    avatarContainer: { position: 'relative', flexShrink: 0 },
    avatar: {
      width: '52px',
      height: '52px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      fontWeight: '700',
      fontSize: '18px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      border: `3px solid ${c.sidebarBg}`,
      transition: 'all 0.2s ease',
    },
    onlineIndicator: {
      position: 'absolute',
      bottom: '2px',
      right: isRTL ? 'auto' : '2px',
      left: isRTL ? '2px' : 'auto',
      width: '16px',
      height: '16px',
      background: c.online,
      border: `3px solid ${c.sidebarBg}`,
      borderRadius: '50%',
      boxShadow: '0 2px 8px rgba(34, 197, 94, 0.4)',
    },
    chatArea: {
      display: !initState.selectedUser && isMobile ? 'none' : 'flex',
      flex: 1,
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
      minWidth: 0,
      background: c.chatBg,
    },
    chatHeader: {
      background: c.sidebarBg,
      backdropFilter: c.glassEffect,
      borderBottom: `1px solid ${c.border}`,
      padding: '16px 20px',
      flexShrink: 0,
    },
    rightPanel: {
      display: initState.selectedUser && !isMobile && showRightPanel ? 'flex' : 'none',
      width: '320px',
      minWidth: '320px',
      background: c.panelBg,
      backdropFilter: c.glassEffect,
      borderLeft: isRTL ? 'none' : `1px solid ${c.border}`,
      borderRight: isRTL ? `1px solid ${c.border}` : 'none',
      flexDirection: 'column',
      padding: '20px',
      gap: '18px',
      overflowY: 'auto',
    },
    rightCard: {
      background: c.inputBg,
      border: `1px solid ${c.border}`,
      borderRadius: '20px',
      padding: '18px',
      boxShadow: c.softShadow,
    },
    statGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '10px',
      marginTop: '14px',
    },
    statItem: {
      background: theme === 'dark' ? 'rgba(255,255,255,0.03)' : '#f8fafc',
      border: `1px solid ${c.border}`,
      borderRadius: '16px',
      padding: '12px',
      textAlign: 'center',
    },
    galleryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '10px',
    },
    galleryItem: {
      aspectRatio: '1 / 1',
      borderRadius: '14px',
      overflow: 'hidden',
      background: theme === 'dark' ? 'rgba(255,255,255,0.05)' : '#e2e8f0',
      cursor: 'pointer',
      border: `1px solid ${c.border}`,
    },
    backButton: {
      padding: '10px',
      background: 'transparent',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      display: isMobile ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      color: c.text,
      transition: 'all 0.2s ease',
    },
    messagesContainer: {
      position: 'relative',
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: isMobile ? '16px' : '24px',
      backgroundColor: theme === 'dark' ? 'rgba(15, 23, 42, 0.55)' : 'rgba(255, 255, 255, 0.02)',
      // Chat wallpaper disabled per request — kept for easy re-enable.
      // backgroundImage: theme === 'dark'
      //   ? 'url("/BG-Chats-Massagepage-Dark.png")'
      //   : 'url("/BG-Chats-Massagepage-light.png")',
      // backgroundSize: 'cover',
      // backgroundPosition: 'center',
      // backgroundRepeat: 'no-repeat',
      // backgroundBlendMode: 'overlay',
      borderRadius: '24px',
      border: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.08)'}`,
      minHeight: 0,
    },
    messageWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '10px',
      marginBottom: '4px',
      width: '100%',
    },
    messageBubble: {
      padding: '10px 16px',
      borderRadius: '20px',
      fontSize: '15px',
      // Increased maxWidth so long messages look better on wide screens
      maxWidth: isMobile ? '92%' : '500px',
      minWidth: '40px',
      wordBreak: 'break-word',
      transition: 'all 0.2s ease',
      position: 'relative',
      lineHeight: '1.55',
    },
    myMessage: {
      background: c.myMessageGradient || '#2e7cba',
      color: '#ffffff',
      borderBottomRightRadius: isRTL ? '20px' : '6px',
      borderBottomLeftRadius: isRTL ? '6px' : '20px',
      marginLeft: isRTL ? '0' : 'auto',
      marginRight: isRTL ? 'auto' : '0',
      boxShadow: c.myBubbleShadow || '0 4px 20px rgba(46, 124, 186, 0.25)',
      border: 'none',
    },
    theirMessage: {
      background: theme === 'dark'
        ? 'linear-gradient(135deg, rgba(148, 163, 184, 0.45) 0%, rgba(100, 116, 139, 0.45) 100%)'
        : 'linear-gradient(135deg, #645c5cff 0%, #585c61ff 100%)',
      color: '#ffffff',
      borderBottomRightRadius: isRTL ? '6px' : '20px',
      borderBottomLeftRadius: isRTL ? '20px' : '6px',
      marginRight: isRTL ? '0' : 'auto',
      marginLeft: isRTL ? 'auto' : '0',
      //boxShadow: theme === 'dark' ? (c.bubbleShadow || '0 4px 20px rgba(0, 0, 0, 0.15)') : 'none',
      backdropFilter: theme === 'dark' ? 'blur(12px)' : 'none',
      WebkitBackdropFilter: theme === 'dark' ? 'blur(12px)' : 'none',
      border: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'transparent'}`,
    },
    inputArea: {
      background: c.sidebarBg,
      backdropFilter: c.glassEffect,
      borderTop: `1px solid ${c.border}`,
      padding: isMobile ? '16px' : '12px',
      flexShrink: 0,
    },
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? '8px' : '12px',
      background: c.inputBg,
      borderRadius: '28px',
      padding: '8px 12px',
      border: `2px solid ${c.inputBorder}`,
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    },
    iconButton: {
      padding: '10px',
      color: '#2e7cba',
      background: 'transparent',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      flexShrink: 0,
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    messageInput: {
      flex: 1,
      padding: '12px 16px',
      background: 'transparent',
      border: 'none',
      outline: 'none',
      fontSize: '15px',
      color: c.text,
      minHeight: '44px',
      resize: 'none',
      fontFamily: 'inherit',
      lineHeight: '1.5',
    },
    sendButton: {
      padding: '12px',
      background: 'linear-gradient(135deg, #2e7cba, #3b82f6)',
      color: '#ffffff',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      flexShrink: 0,
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
    },
    sendButtonDisabled: {
      background: c.textSecondary,
      cursor: 'not-allowed',
      boxShadow: 'none',
    },
    emptyState: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: c.chatBg,
      padding: '20px',
    },
    emptyStateContent: { textAlign: 'center', color: c.textSecondary },
    emptyStateIcon: {
      width: '100px',
      height: '100px',
      background: 'linear-gradient(135deg, #2e7cba 0%, #2e7cba 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px',
      boxShadow: '0 8px 24px rgba(59, 130, 246, 0.3)',
    },
    emptyStateTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: c.text,
      marginBottom: '8px',
      margin: '0 0 8px 0',
    },
    emptyStateText: { color: c.textSecondary, margin: 0, fontSize: '15px' },
    loadingContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: c.sidebarBg,
      backdropFilter: c.glassEffect,
      borderRadius: isMobile ? '0' : '20px',
      boxShadow: c.shadow,
      margin: '0',
      boxSizing: 'border-box',
      minHeight: 0,
    },
    loadingText: { textAlign: 'center', fontSize: '18px', color: c.textSecondary },
    errorContainer: { textAlign: 'center', color: '#ef4444' },
    errorTitle: { fontSize: '18px', fontWeight: '600', marginBottom: '8px' },
    errorMessage: { fontSize: '14px', marginBottom: '16px' },
    retryButton: {
      padding: '12px 24px',
      background: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '600',
      transition: 'all 0.2s ease',
      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    },
  });
}

